import React from 'react';
import classNames from 'classnames';
import bowser from 'yola-bowser';
import noop from '../utils/noop';
import { iconsList } from '../icon/glyphs';
import Icon from '../icon';
import Render from '../render';

// @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
function MenuItem({
  type = 'default',
  icon = null,
  active = false,
  onClick = noop,
  onMouseEnter = noop,
  onMouseLeave = noop,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
  className = null,
  children = null,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
  href = null,
  disabled = false,
  target = '_self',
  ...otherProps
}) {
  const isMobile = bowser.mobile || bowser.tablet;
  const menuItemClass = classNames('ws-menu-item', className, {
    'ws-menu-item--divider': type === 'divider',
    'ws-menu-item--active': active,
    'ws-menu-item--mobile': isMobile,
    'ws-menu-item--disabled': disabled,
  });

  if (type === 'divider') {
    return <li className={menuItemClass} {...otherProps} />;
  }

  return (
    <li
      className={menuItemClass}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      {...otherProps}
    >
      <Render if={Boolean(icon)}>
        {/* @ts-ignore TS(2322): Type '{ className: string; glyph: any; }' is not a... Remove this comment to see the full error message */}
        <Icon className="ws-menu-item__icon" glyph={icon} />
      </Render>
      {/* @ts-ignore TS(2322): Type 'string | number | boolean | ReactElement<any... Remove this comment to see the full error message */}
      <Render if={!href}>{children}</Render>
      <Render if={Boolean(href)}>
        <a className="ws-menu-item--link" {...otherProps} href={href} target={target}>
          {children}
        </a>
      </Render>
    </li>
  );
}

export default MenuItem;
